// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txTe4xzIESLRaej4BRpn {
  display: flex;
  padding-top: 2.8125rem;
}

.sniXCiOgjNk9m0wRpYG2 {
  flex: 1 1 0;
  align-content: flex-start;
}

.nwzQAApQO2xOvRkZa_8a {
  max-width: calc(90rem / 2);
  padding: 2rem 1.25rem 0 2.5rem;
}

.K0qcSZXMbMV3lT88gxuv {
  margin-bottom: 2.5rem;
}

.UawHJrvGtIJ4V_1oI30U {
  margin-bottom: 5.9375rem;
}

.dqHXBilKVKdVXUmYjVRH {
  position: relative;
  margin-top: 6rem
}

.dqHXBilKVKdVXUmYjVRH img {
    margin-bottom: 17.5rem;
  }

ul.jXEOAcATjuaMWRhGxG62 {
  margin-bottom: 2rem;
}

div.fja9LOBC8yJfAv2NRtQ8 {
  margin-bottom: 2rem;
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .w1AVBkEcd2Pl5amNGpAO {
    margin-bottom: 3.125rem;
  }
}

@media only screen and
  (min-width: 1280px) {
  .w1AVBkEcd2Pl5amNGpAO {
    margin-bottom: 3.125rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .nwzQAApQO2xOvRkZa_8a {
    max-width: 100%;
    padding: 2rem 2.1875rem;
  }

  .txTe4xzIESLRaej4BRpn {
    flex-direction: column;
    padding-top: 0.5rem;
  }

  .K0qcSZXMbMV3lT88gxuv {
    margin-bottom: 1.5rem;
  }

  .dqHXBilKVKdVXUmYjVRH {
    margin-top: 0
  }

    .dqHXBilKVKdVXUmYjVRH img {
      margin-bottom: 0;
    }
}

@media only screen and
  (max-width: 639px) {
  .nwzQAApQO2xOvRkZa_8a {
    max-width: 100%;
    padding: 2rem 1.25rem;
  }

  .txTe4xzIESLRaej4BRpn {
    flex-direction: column;
    padding-top: 0.5rem;
  }

  .K0qcSZXMbMV3lT88gxuv {
    margin-bottom: 1.5rem;
  }

  .dqHXBilKVKdVXUmYjVRH {
    margin-top: 0
  }

    .dqHXBilKVKdVXUmYjVRH img {
      margin-bottom: 0;
    }

  div.fja9LOBC8yJfAv2NRtQ8 {
    margin-bottom: 2.125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BusinessGiftCardBlock/BusinessGiftCardBlock.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,0BAA2B;EAC3B,8BAAyB;AAC3B;;AAEA;EACE,qBAAmB;AACrB;;AAEA;EACE,wBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB;AAKF;;AAHE;IACE,sBAAoB;EACtB;;AAGF;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EACE;IACE,uBAAmB;EACrB;AACF;;AAEA;;EACE;IACE,uBAAmB;EACrB;AACF;;AAEA;;;EACE;IACE,eAAe;IACf,uBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAgB;EAClB;;EAEA;IACE,qBAAmB;EACrB;;EAEA;IACE;EAKF;;IAHE;MACE,gBAAgB;IAClB;AAEJ;;AAEA;;EACE;IACE,eAAe;IACf,qBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAgB;EAClB;;EAEA;IACE,qBAAmB;EACrB;;EAEA;IACE;EAKF;;IAHE;MACE,gBAAgB;IAClB;;EAGF;IACE,uBAAmB;EACrB;AACF","sourcesContent":[".businessGiftCardBlock {\n  display: flex;\n  padding-top: 45px;\n}\n\n.productOrderContainer {\n  flex: 1 1 0;\n  align-content: flex-start;\n}\n\n.productOrderWrapper {\n  max-width: calc(1440px / 2);\n  padding: 32px 20px 0 40px;\n}\n\n.title {\n  margin-bottom: 40px;\n}\n\n.productImageContainer {\n  margin-bottom: 95px;\n}\n\n.imagePreviewContainer {\n  position: relative;\n  margin-top: 96px;\n\n  & img {\n    margin-bottom: 280px;\n  }\n}\n\nul.productDetailsUsps {\n  margin-bottom: 32px;\n}\n\ndiv.productDetailsBrandsBlock {\n  margin-bottom: 32px;\n}\n\n@media (--desktop-small) {\n  .redirectButton {\n    margin-bottom: 50px;\n  }\n}\n\n@media (--desktop-large) {\n  .redirectButton {\n    margin-bottom: 50px;\n  }\n}\n\n@media (--tablet) {\n  .productOrderWrapper {\n    max-width: 100%;\n    padding: 32px 35px;\n  }\n\n  .businessGiftCardBlock {\n    flex-direction: column;\n    padding-top: 8px;\n  }\n\n  .title {\n    margin-bottom: 24px;\n  }\n\n  .imagePreviewContainer {\n    margin-top: 0;\n\n    & img {\n      margin-bottom: 0;\n    }\n  }\n}\n\n@media (--mobile) {\n  .productOrderWrapper {\n    max-width: 100%;\n    padding: 32px 20px;\n  }\n\n  .businessGiftCardBlock {\n    flex-direction: column;\n    padding-top: 8px;\n  }\n\n  .title {\n    margin-bottom: 24px;\n  }\n\n  .imagePreviewContainer {\n    margin-top: 0;\n\n    & img {\n      margin-bottom: 0;\n    }\n  }\n\n  div.productDetailsBrandsBlock {\n    margin-bottom: 34px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"businessGiftCardBlock": `txTe4xzIESLRaej4BRpn`,
	"productOrderContainer": `sniXCiOgjNk9m0wRpYG2`,
	"productOrderWrapper": `nwzQAApQO2xOvRkZa_8a`,
	"title": `K0qcSZXMbMV3lT88gxuv`,
	"productImageContainer": `UawHJrvGtIJ4V_1oI30U`,
	"imagePreviewContainer": `dqHXBilKVKdVXUmYjVRH`,
	"productDetailsUsps": `jXEOAcATjuaMWRhGxG62`,
	"productDetailsBrandsBlock": `fja9LOBC8yJfAv2NRtQ8`,
	"redirectButton": `w1AVBkEcd2Pl5amNGpAO`
};
export default ___CSS_LOADER_EXPORT___;
